import TITLES from "constants/titles";
import { getFullName } from "utils/common";

import { CURRENT_USER_OPTIONS } from "../merge-tags-options/current-user.utils";
import { MergeTagsReplaceHandler } from "./merge-tags-values";

export const CURRENT_USER_VALUES: MergeTagsReplaceHandler = {
  [CURRENT_USER_OPTIONS.FULLNAME]: ({ data }) => {
    return getFullName({
      firstName: data.currentUser?.first_name || "",
      lastName: data.currentUser?.last_name || "",
      title: data.currentUser?.title,
      suffix: data.currentUser?.suffix || ""
    });
  },
  [CURRENT_USER_OPTIONS.FIRST_NAME]: ({ data }) => {
    return data.currentUser?.first_name;
  },
  [CURRENT_USER_OPTIONS.LAST_NAME]: ({ data }) => {
    return data.currentUser?.last_name;
  },
  [CURRENT_USER_OPTIONS.TITLE]: ({ data }) => {
    return TITLES.getFromCode(data.currentUser?.title);
  },
  [CURRENT_USER_OPTIONS.SUFFIX]: ({ data }) => {
    return data.currentUser?.suffix;
  },
  [CURRENT_USER_OPTIONS.SIGNATURE]: ({ data }) => {
    if (!data.currentUser?.signature) return null;

    return `<img src="${data.currentUser?.signature}" alt="User mergetag signature" width="350">`;
  }
};
